<template>
  <v-container fluid class="pa-5 pb-16 elevation-1">
    <v-sheet class="pa-4 w-100" color="#194c9b" elevation="2" rounded>
      <h1 class="text-h4 font-weight-bold d-flex align-center">
        <v-btn icon color="blue" variant="text">
          <v-icon>mdi-account-cash</v-icon>
        </v-btn>
        <span class="ml-2">
          Límites de mi Unidad
          <template v-if="budget?.unidad_nombre"> — {{ budget.unidad_nombre }}</template>
        </span>
        <!-- <v-btn
          :loading="loading"
          class="ml-auto"
          color="white"
          variant="tonal"
          prepend-icon="mdi-refresh"
          @click="cargar"
        >
          Actualizar
        </v-btn> -->
      </h1>
    </v-sheet>

   

    <div v-if="loading" class="loader mt-6">
      <v-progress-circular indeterminate color="primary" />
      <div class="mt-2 text-medium-emphasis">Cargando…</div>
    </div>

    <template v-else>
      <!-- Presupuesto de la unidad -->
      <v-row class="mt-1" dense>
        <v-col cols="12" sm="6" md="3">
          <v-card class="kpi-card" variant="flat" rounded="lg">
            <div class="kpi-label">Presupuesto</div>
            <div class="kpi-value">{{ money(budget?.limite_usd) }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card class="kpi-card" variant="flat" rounded="lg">
            <div class="kpi-label">Asignado</div>
            <div class="kpi-value">{{ money(budget?.asignado) }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card class="kpi-card" variant="flat" rounded="lg">
            <div class="kpi-label">Disponible</div>
            <div class="kpi-value verde">{{ money(budget?.disponible) }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card class="kpi-card" variant="flat" rounded="lg">
            <div class="kpi-label">Gastado</div>
            <div class="kpi-value">{{ money(budget?.gastado) }}</div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Barra: presupuesto repartido -->
      <div class="barra-container mt-3">
        <div class="barra-info">
          <span>Presupuesto repartido a usuarios</span>
          <span class="porcentaje">{{ pctAsignado.toFixed(1) }}%</span>
        </div>
        <div class="barra">
          <div
            class="barra-fill"
            :style="{ width: Math.min(pctAsignado, 100) + '%', background: colorBarra }"
          ></div>
        </div>
        <div v-if="pctAsignado >= 100" class="barra-aviso">
          ⚠️ Ya repartiste todo el presupuesto de tu unidad. No puedes asignar más
          hasta que el Admin lo amplíe (disponible: {{ money(budget?.disponible) }}).
        </div>
      </div>

      <!-- Barra: presupuesto gastado (consumido) -->
      <div class="barra-container mt-3">
        <div class="barra-info">
          <span>Presupuesto consumido (gastado)</span>
          <span class="porcentaje">{{ pctGastado.toFixed(1) }}%</span>
        </div>
        <div class="barra">
          <div
            class="barra-fill"
            :style="{ width: Math.min(pctGastado, 100) + '%', background: colorGastado }"
          ></div>
        </div>
        <div v-if="pctGastado >= 100" class="barra-aviso">
          ⚠️ Tu unidad ya consumió todo el presupuesto.
        </div>
      </div>

      <!-- Usuarios de la unidad -->
      <v-table v-if="users.length" class="mt-3">
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Email</th>
             <th>Rol User </th>
            <th>Gastado</th>
            <th>Límite USD</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="u in paged" :key="u.id">
            <td>
              <b>{{ u.username }}</b>
            </td>
            <td>{{ u.email || "—" }}</td>
             <!-- //span v-for="group in u.groups  :key="group> {{ group}}  esto en caso de ser mas de uno -->
             <td>{{u.groups[0]}}</td>
            <td>${{ Number(u.total_spent || 0).toFixed(4) }}</td>

            <td v-if="editando !== u.id">${{ Number(u.limit_usd || 0).toFixed(2) }}</td>
            <td v-else>
              <input
                type="number"
                step="0.01"
                min="0"
                v-model.number="nuevoLimite"
                class="input-num"
              />
            </td>

            <td>
              <template v-if="editando !== u.id">
                <button class="btn-sm" @click="editar(u)">Editar</button>
              </template>
              <template v-else>
                <button class="btn-sm btn-primary" :disabled="guardando" @click="guardar(u)">
                  {{ guardando ? "..." : "Guardar" }}
                </button>
                <button class="btn-sm" @click="cancelar">Cancelar</button>
              </template>
            </td>
          </tr>
        </tbody>
      </v-table>

      <v-alert v-else type="info" variant="tonal" class="mt-4">
        No hay usuarios en tu unidad.
      </v-alert>

      <!-- FOOTER / PAGINACIÓN -->
      <div
        v-if="users.length"
        class="d-flex align-center justify-space-between flex-wrap ga-3 px-4 pb-4 table-footer"
      >
        <div class="d-flex align-center ga-2">
          <span class="text-caption text-medium-emphasis">{{ $t("paginacion") }}</span>
          <v-select
            v-model="itemsPerPage"
            :items="[5, 10, 15, 20]"
            density="compact"
            variant="outlined"
            hide-details
            style="max-width: 110px"
          />
        </div>
        <v-pagination v-model="page" :length="pageCount" density="comfortable" :total-visible="6" />
      </div>
    </template>

  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { getUnitBudget, getUnitUsers, setUserLimit } from "@/api/managerLimits";
import { swal } from "@/utils/swal";
import { useSettingsStore } from "@/stores/settings";


const budget = ref(null);
const users = ref([]);
const loading = ref(true);
const error = ref("");
const itemsPerPage = ref(10);
const page = ref(1);

// Edición inline
const editando = ref(null);
const nuevoLimite = ref(0);
const guardando = ref(false);

const isDark = computed(() => useSettingsStore().theme === "dark");

function money(v) {
  return `$${Number(v || 0).toFixed(2)}`;
}

// % del presupuesto ya repartido (asignado / limite). Rige "no puede asignar más".
const pctAsignado = computed(() => {
  const lim = Number(budget.value?.limite_usd || 0);
  const asig = Number(budget.value?.asignado || 0);
  return lim > 0 ? (asig / lim) * 100 : 0;
});
// % del presupuesto ya consumido (gastado / limite)
const pctGastado = computed(() => {
  const lim = Number(budget.value?.limite_usd || 0);
  const gas = Number(budget.value?.gastado || 0);
  return lim > 0 ? (gas / lim) * 100 : 0;
});
function colorPorPct(p) {
  if (p >= 100) return "#dc2626";
  if (p >= 80) return "#f59e0b";
  if (p >= 50) return "#eab308";
  return "#10b981";
}
const colorBarra = computed(() => colorPorPct(pctAsignado.value));
const colorGastado = computed(() => colorPorPct(pctGastado.value));
function popupClass() {
  return {
    popup: isDark.value ? "mi-popup" : "mi-popup-2",
    title: "mi-titulo",
  };
}

async function cargar() {
  loading.value = true;
  error.value = "";
  try {
    const [b, u] = await Promise.all([getUnitBudget(), getUnitUsers()]);
     console.log("WWWWE", u)
    budget.value = b;
    users.value = u;
   
  } catch (e) {
    error.value =
      e.response?.status === 403
        ? "No tienes permiso para ver esta información."
        : "Error al cargar la información de tu unidad.";
  } finally {
    loading.value = false;
  }
}
onMounted(cargar);

function editar(u) {
  editando.value = u.id;
  nuevoLimite.value = u.limit_usd ?? 0;
}
function cancelar() {
  editando.value = null;
}

async function guardar(u) {
  guardando.value = true;
  error.value = "";
  try {
    // Conservamos el estado actual del usuario (el Manager no activa/desactiva)
    await setUserLimit(u.id, Number(nuevoLimite.value || 0), u.is_active !== false);
    editando.value = null;
    await cargar();
  } catch (e) {
    const d = e.response?.data;
    if (e.response?.status === 400) {
      error.value = `${d?.error || "Excede el presupuesto"}${
        d?.disponible != null ? ` (disponible: $${d.disponible})` : ""
      }`;
       await swal({
          icon: "error",
          title: "Error",
          text: error.value,
          customClass: popupClass(),
        });
    } else if (e.response?.status === 403) {
      error.value = d?.error || "Ese usuario no es de tu unidad.";
       await swal({
          icon: "error",
          title: "Error",
          text: error.value,
          customClass: popupClass(),
        });
      
    } else {
       await swal({
          icon: "error",
          title: "Error",
          text: "No se pudo guardar el limite.",
          customClass: popupClass(),
        });
    }
  } finally {
    guardando.value = false;
  }
}
const pageCount = computed(() =>
  Math.max(1, Math.ceil(users.value.length / (Number(itemsPerPage.value) || 10))),
);
const paged = computed(() => {
  const per = Number(itemsPerPage.value) || 10;
  const start = (page.value - 1) * per;
  console.log("WWWW", users)
  return users.value.slice(start, start + per);
});
</script>

<style scoped>
.loader {
  text-align: center;
  padding: 40px;
}
.kpi-card {
  background: #f7f9fc;
  border: 1px solid #e6eaf1;
  padding: 18px;
}
.kpi-label {
  color: #6b7280;
  font-size: 13px;
  margin-bottom: 6px;
}
.kpi-value {
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
}
.verde {
  color: #059669;
}

.barra-container {
  margin-bottom: 8px;
}
.barra-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 14px;
  color: #374151;
}
.porcentaje {
  font-weight: 600;
}
.barra {
  width: 100%;
  height: 14px;
  background: #e5e7eb;
  border-radius: 7px;
  overflow: hidden;
}
.barra-fill {
  height: 100%;
  border-radius: 7px;
  transition: width 0.4s ease, background 0.3s ease;
}
.barra-aviso {
  margin-top: 8px;
  color: #991b1b;
  background: #fee2e2;
  border: 1px solid #fecaca;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
}

button {
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: white;
  cursor: pointer;
  font-size: 14px;
}
.btn-sm {
  padding: 4px 10px;
  font-size: 13px;
  margin-right: 4px;
}
.btn-primary {
  background: #1e40af;
  color: white;
  border-color: #1e40af;
}
.btn-danger {
  background: #dc2626;
  color: white;
  border-color: #dc2626;
}
button:disabled {
  opacity: 0.6;
  cursor: wait;
}
th,
td {
  padding: 10px 12px;
  text-align: left;
}
th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
}
.input-num {
  width: 110px;
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 14px;
}
</style>
